"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenLoanProductType = void 0;
/**
 * Canonical values that appear in `DIM_LOAN_APP.PRODUCT` (and equivalent columns downstream). These
 * classify a loan application by product type - HELOC (home equity) products like MOAP / AC vs UCC
 * card products like REWARDS / FLEX. This is independent of any specific origination channel;
 * consumers that want to filter to e.g. HIL (merchant-originated) applications should join with the
 * relevant channel column and use these values to bucket by product.
 *
 * Kept as one enum so code that touches loanApp product values can reference them symbolically instead
 * of scattering raw string literals across queries and manager code.
 */
var AvenLoanProductType;
(function (AvenLoanProductType) {
    // HELOC (secured) products
    AvenLoanProductType["MOAP"] = "MOAP";
    AvenLoanProductType["AC"] = "AC";
    // UCC card (unsecured) products
    AvenLoanProductType["REWARDS"] = "REWARDS";
    AvenLoanProductType["FLEX"] = "FLEX";
})(AvenLoanProductType || (exports.AvenLoanProductType = AvenLoanProductType = {}));
